export default __webpack_public_path__ + "static/media/image.kynd-fashion-truck.d1184213.png";